module.exports = __webpack_public_path__ + "static/media/job_add_on_tag.ed1e833b.svg";